import r, { keyframes as t, css as p } from "styled-components";
import { Button as l } from "./atoms-v26.js";
import { breakpoints as s } from "./atoms-v2125.js";
const g = t`
  from { opacity: 0; }
  to { opacity: 1; }
`, b = r.div`
  animation-duration: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.fast")};
  animation-name: ${g};
  animation-timing-function: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("easing.entrance")};
  bottom: 0;
  box-sizing: border-box;
  color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.colors.red.60")};
  column-gap: var(--gap);
  display: flex;
  font-family: 'Monaspace Neon Selfbook', monospace;
  font-size: 12px;
  left: 50%;
  pointer-events: none;
  position: fixed;
  top: 0;
  transform: translate3d(-50%, 0, 0);
  width: 100%;
  z-index: 100;

  &::before {
    background-color: rgba(255 0 0/0.1);
    bottom: 12px;
    box-shadow: inset 0 0 0 1px rgb(255 0 0/0.4);
    color: rgb(255 0 0/0.8);
    font-size: 11px;
    left: 50%;
    padding: 3px 6px;
    position: absolute;
    text-align: center;
    transform: translate3d(-50%, 0, 0);
  }

  & div {
    background-color: rgba(255 0 0/0.06);
    box-shadow:
      inset 1px 0 0 rgb(255 0 0/0.2),
      inset -1px 0 0 rgb(255 0 0/0.2);
    display: flex;
    flex-basis: calc(100% / var(--columns) - var(--gap) / var(--columns) * (var(--columns) - 1));
    justify-content: center;
    padding: 12px 0;
  }

  ${({ theme: o }) => Object.keys(s).map((n) => {
  const i = o == null ? void 0 : o.get("tokens.breakpoints.max.columns"), a = i - (o == null ? void 0 : o.get(`tokens.breakpoints.${n}.columns`));
  return p`
        @media ${s[n]} {
          --columns: ${o == null ? void 0 : o.get(`tokens.breakpoints.${n}.columns`)};
          --gap: ${o == null ? void 0 : o.get(`tokens.breakpoints.${n}.gutter`)}px;

          padding-left: ${o == null ? void 0 : o.get(`tokens.breakpoints.${n}.margin`)}px;
          padding-right: ${o == null ? void 0 : o.get(`tokens.breakpoints.${n}.margin`)}px;

          &::before {
            content: '< ${n} >';
          }
          & div:nth-last-child(-n + ${a || i}) {
            display: ${a > 0 ? "none" : "flex"};
          }
        }
      `;
})}
`, f = r(l)`
  bottom: 10px;
  left: 10px;
  position: fixed;
  z-index: 999999;
`;
export {
  b as Helper,
  f as Toggle
};
